<div *ngIf="!statGroupResults?.length" class="font-italic text-secondary">Stats not available</div>
<div *ngIf="statGroupResults?.length" class="d-flex flex-wrap mb-1" style="max-width:100%;overflow-x: auto;">
  <div *ngFor="let statGroupResult of statGroupResults; let index=index;" class="card p-1 mb-1 mr-2 {{statGroupResult.visible?'w-100':''}} bg-light">
    <ng-template fesListView
      #fesListView
      let-statGroupRows
      [fesListViewOf]="statGroupResult.rows"
      >
    <div class="font-weight-bold mt-1 mx-2" role="button" (click)="toggleGroupVisible(statGroupResult)">
      <i class="mr-2 fa {{loadingStatsById[statGroupResult.id]?'fa-spinner fa-spin':'fa-chevron-'+(statGroupResult.visible?'down':'right')}}"></i>
      {{statGroupResult.title}}
    </div>
    <table [ngClass]="{'d-none': !statGroupResult.visible}" class="m-0 p-0 mb-1 table table-sm table-striped table-bordered" style="height:1px;">
      <thead>
        <ng-template
          fesListView
          [fesListViewOf]="statGroupResult.metrics"
          (filtered)="onVisibleMetricsChange($event, statGroupResult.metrics)"
          let-visibleMetrics>
        <tr>
          <th [attr.colspan]="statGroupResult.groupBy.length">
            <app-filter-field-config *ngIf="statGroupResult.metrics.length>maxNoFilterColumns">
            <input type="text" class="w-100" size="12" placeholder="Metric Title Filter -->"
            style="background-color: rgba(232,232,232); min-width:8em;" [fesFilterField]="'title'"/>
            </app-filter-field-config>
          </th>
          <th *ngFor="let metric of visibleMetrics" [attr.colspan]="metric.statTypes.length">
            {{metric.title}}</th>
        </tr>
        </ng-template>
        <tr>
          <th *ngFor="let groupingCol of statGroupResult.groupBy;" [fesSortField]="groupingCol"
          [sortType]="sortTypesByColumnType[groupingCol]??'string'">
            {{columnTitles[groupingCol]??groupingCol}}
          </th>
          <ng-container *ngFor="let metric of statGroupResult.metrics">
            <ng-container *ngFor="let statType of metric.statTypes">
              <th [fesSortField]="metric.column+'_'+statType" rowspan=2 *ngIf="!metric.hidden"
              [sortType]="sortTypeByStatDataType[metric.format?.dataType]??sortTypesByColumnType[metric.column]??'numeric'">
              {{statType}}
            </th>
            </ng-container>
          </ng-container>
        </tr>
        <tr *ngIf="statGroupResult.rows.length>maxNoFilterRows">
          <th *ngFor="let groupingCol of statGroupResult.groupBy;">
            <app-filter-field-config>
              <input type="text" class="w-100" size="12" style="min-width:8em" [fesFilterField]="groupingCol"/>
            </app-filter-field-config>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadingStatsById[statGroupResult.id]; else notLoadingStats">
        <tr>
          <td [attr.colspan]="statGroupResult.groupBy.length + (statGroupResult.metrics.length*6)">
            Loading...
          </td>
        </tr>
        </ng-container>
        <ng-template #notLoadingStats>
          <ng-container *ngIf="isVisible && statGroupResult.visible">
        <tr *ngFor="let statRow of statGroupRows">
          <td *ngFor="let groupingCol of statGroupResult.groupBy">{{statRow[groupingCol]}}</td>
          <ng-container *ngFor="let metric of statGroupResult.metrics">
            <ng-container *ngIf="!metric.hidden">
            <td *ngFor="let statType of metric.statTypes">
              <ng-container [ngSwitch]="metric.format?.dataType??sortTypesByColumnType[metric.column]"
              ><ng-container *ngSwitchCase="'date'">{{
                  statRow[metric.column+'_'+statType]|date:metric.format?.layout??'M/d/yy, h:mm:ss.SS a'
                }}</ng-container><ng-container *ngSwitchCase="'number'">{{
                  statRow[metric.column+'_'+statType]|number:metric.format?.layout??'1.0-3'
                }}</ng-container><ng-container *ngSwitchDefault>{{
                  formatStatValue(statRow[metric.column + '_' + statType], metric.format?.layout ?? '1.0-3')
                }}</ng-container></ng-container>
            </td>
          </ng-container>
          </ng-container>
        </tr>
          </ng-container>
        </ng-template>
      </tbody>
    </table>
  </ng-template>
  </div>
</div>